import { getContent } from '@ynap/content-state'

export default function getPreferences(state) {
    const {
        location,
        locale,
        user,
        content,
        isFetchingUser,
        fetchUserError,
        country,
        isFetchingCountry,
        fetchCountryError,
        isUpdatingUserMarketingCountryLang,
        updateUserMarketingCountryLangError,
    } = state

    const isFetchingContent = content['subscribe-preferences-collection']?.loading
    const fetchContentError = content['subscribe-preferences-collection']?.error

    const marketingConsent = user?.contextAttribute.find((attr) => attr.attributeName === 'maMarketingConsent')
        ?.attributeValue[0]?.value[0]
    const loyaltyConsentAttr = user?.contextAttribute.find((attr) => attr.attributeName === 'maLoyaltyConsent')
    const isEip = user?.customerSegments?.customerLevelOfService?.some(({ customerSegmentName }) =>
        customerSegmentName.includes('EIP')
    )
    const isStaff = user?.customerSegments?.customerCategory?.some(({ customerSegmentName }) =>
        customerSegmentName.toLowerCase().includes('staff')
    )
    const preferredCountry = user?.contextAttribute?.find((attr) => attr.attributeName === 'maPreferredCountry')
        ?.attributeValue[0]?.value[0]
    const preferredLanguage = user?.preferredLanguage
    const gender = user?.gender

    const getLoyaltyConsentValue = () => {
        return Array.isArray(loyaltyConsentAttr.attributeValue)
            ? { maLoyaltyConsent: JSON.parse(loyaltyConsentAttr.attributeValue[0]?.value[0]) }
            : { maLoyaltyConsent: JSON.parse(loyaltyConsentAttr.attributeValue?.value) }
    }

    const userPreferences = {
        marketingConsent,
        isEip,
        isStaff,
        preferredCountry,
        preferredLanguage,
        ...(gender && { gender: gender }),
        ...(loyaltyConsentAttr && { loyaltyConsent: getLoyaltyConsentValue() }),
    }

    return {
        location,
        locale,
        country,
        isFetchingCountry,
        fetchCountryError,
        isFetchingUser,
        fetchUserError,
        content: getContent(state, 'subscribe-preferences-collection'),
        isFetchingContent,
        fetchContentError,
        isUpdatingUserMarketingCountryLang,
        updateUserMarketingCountryLangError,
        userPreferences,
    }
}
